import { render, staticRenderFns } from "./relation-hotel-list.vue?vue&type=template&id=3efb1170&scoped=true"
import script from "./relation-hotel-list.vue?vue&type=script&lang=js"
export * from "./relation-hotel-list.vue?vue&type=script&lang=js"
import style0 from "./relation-hotel-list.vue?vue&type=style&index=0&id=3efb1170&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efb1170",
  null
  
)

export default component.exports